import { Injectable } from '@angular/core';
import { NgbModal }   from '@ng-bootstrap/ng-bootstrap';

import { AlertModalOptionsModel }   from './models/modal.alert.options';
import { CaptureModalOptionsModel } from './models/modal.capture.options';
import { NoteModalOptionsModel }    from './models/modal.note.options';

import { AlertModalComponent }   from './modal.alert.component';
import { CaptureModalComponent } from './modal.capture.component';
import { NoteModalComponent }    from './modal.note.component';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  constructor(
    private modalService: NgbModal
  ) {}

  private openModal ( content : any, options : any ) : Promise<any> {
    const modal = this.modalService.open(content);

    modal.componentInstance.options = options;

    return modal.result;
  }

  addNote ( options : NoteModalOptionsModel ) : Promise<any> {
    return this.openModal(NoteModalComponent , options);
  }

  alert ( options : AlertModalOptionsModel ) : Promise<any> {
    return this.openModal(AlertModalComponent , options);
  }

  capture ( options : CaptureModalOptionsModel ) : Promise<string> {
    return this.openModal(CaptureModalComponent , options);
  }
}
